'use client';

import { ToastContainer } from 'react-toastify';

export function AppToastProvider(): React.ReactElement {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      pauseOnHover
      draggable
      theme="colored"
    />
  );
}
